export const LIVE_SESSION_RETURN_URL_STORAGE_KEY = 'aumhum.liveSession.returnUrl'

export function getLocationPath(location = {}) {
  const pathname = typeof location?.pathname === 'string' ? location.pathname : ''
  const search = typeof location?.search === 'string' ? location.search : ''
  const hash = typeof location?.hash === 'string' ? location.hash : ''

  return `${pathname}${search}${hash}`
}

export function isSecuredLiveSessionPath(pathname = '') {
  const normalizedPathname = String(pathname || '')
  return normalizedPathname.startsWith('/l/') || normalizedPathname.startsWith('/webview/l/')
}

function normalizeInternalReturnUrl(value) {
  if (typeof value !== 'string') {
    return null
  }

  const trimmedValue = value.trim()
  if (!trimmedValue || !trimmedValue.startsWith('/')) {
    return null
  }

  return trimmedValue
}

function getPathnameFromReturnUrl(returnUrl) {
  if (!returnUrl) {
    return ''
  }

  return returnUrl.split(/[?#]/)[0] || ''
}

export function rememberLiveSessionReturnUrl(location = {}, storage = null) {
  const pathname = typeof location?.pathname === 'string' ? location.pathname : ''
  if (!storage || !pathname || isSecuredLiveSessionPath(pathname)) {
    return null
  }

  const returnUrl = normalizeInternalReturnUrl(getLocationPath(location))
  if (!returnUrl) {
    return null
  }

  storage.setItem(LIVE_SESSION_RETURN_URL_STORAGE_KEY, returnUrl)
  return returnUrl
}

export function resolveLiveSessionReturnUrl({
  currentPath = '',
  fallbackPath = '/patient-home/sessions',
  locationState = null,
  storage = null,
} = {}) {
  const stateReturnUrl = normalizeInternalReturnUrl(locationState?.returnUrl)
  const stateFromUrl = normalizeInternalReturnUrl(locationState?.from)
  const storedReturnUrl = normalizeInternalReturnUrl(
    storage?.getItem?.(LIVE_SESSION_RETURN_URL_STORAGE_KEY),
  )

  const candidates = [stateReturnUrl, stateFromUrl, storedReturnUrl, fallbackPath]
  return (
    candidates.find((candidate) => {
      const candidatePathname = getPathnameFromReturnUrl(candidate)
      return (
        candidate &&
        candidate !== currentPath &&
        !isSecuredLiveSessionPath(candidatePathname)
      )
    }) || fallbackPath
  )
}
